module.exports = __webpack_public_path__ + "img/service.58025385.jpg";